const DEFAULT_VALUES = ["male", "female"];

export const translateGenderValue = (value, translate = (_, fallback) => fallback) => {
  const normalized = String(value ?? "").trim().toLocaleLowerCase();
  if (!DEFAULT_VALUES.includes(normalized)) return value;

  return translate(
    `field.gender.value.${normalized}`,
    normalized === "male" ? "Male" : "Female"
  );
};

export const hasCanonicalGenderField = (fields = []) => fields.some(
  (field) => field?.slug === "gender" && field?.field_type === "fixed"
);

export const buildGenderOptions = (values = [], currentValue = "", translate = (_, fallback) => fallback) => {
  const options = [];
  const seen = new Set();

  [...DEFAULT_VALUES, ...values, currentValue]
    .map((value) => String(value || "").trim())
    .filter(Boolean)
    .forEach((value) => {
      const normalized = value.toLocaleLowerCase();
      if (seen.has(normalized)) return;
      seen.add(normalized);
      options.push({
        value,
        label: translateGenderValue(value, translate),
      });
    });

  return options;
};
